import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

//https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/clients/${userUID}?page=${page}&limit=${lim}

export const fetchProjectList = createAsyncThunk(
    'projects/fetchProjectList',
    async ({ userUID, page, lim }) => {
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/clients/${userUID}?page=${page}&limit=${lim}`);
       console.log("response.data",response)
        return response.data;
      }
);

export const fetchAllProjectList = createAsyncThunk(
    'projects/fetchAllProjectList',
    async ({ userUID }) => {
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/clients/unlimit/${userUID}`);
       console.log("response.data",response)
        return response.data;
      }
);

const projectReducer = createSlice({
    name: 'projects',
   initialState: {
    data: { clients: [], currentPage: 1, hasNextPage: false, totalPages: 1 },
    allData: { clients: [] }, // For fetchAllProjectList
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        console.log("redux data in", state.data);
      })
      .addCase(fetchProjectList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAllProjectList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllProjectList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allData = action.payload;
        console.log("redux data in", state.allData);
      })
      .addCase(fetchAllProjectList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default projectReducer.reducer;